<template>
  <QuesCard :maxwidth="maxwidth" :ques="ques">
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}矩陣題
    </template>

    <v-card-text class="text-start" slot="content">
      <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="'A' + idx" class="blod quest_topic">
        {{ name }}
      </div>
      <div v-if="ques.questHeadingPic" class="text-center">
        <img
          v-bind:src="$store.state.server + ques.questHeadingPic"
          style="max-width: 100%;"
        />
      </div>

      <div v-if="$store.state.isMobile">
        <div v-for="(subQ, idx) in ques.subQues" :key="'B' + idx">
          {{ subQ.cnName }}
          <v-radio-group v-model="subQ.value">
            <v-card
              class="pa-3 mb-2"
              v-for="(opt, idx2) in ques.items"
              :key="'C' + idx2"
              :ripple="false"
            >
              <v-radio :value="idx2" :label="opt"></v-radio>
            </v-card>
          </v-radio-group>
        </div>
      </div>
      <v-data-table
        v-if="!$store.state.isMobile"
        :headers="ques.items"
        hide-default-header
        :items="ques.subQues"
        hide-default-footer
        class="mt-5"
      >
        <template slot="header" slot-scope="props">
          <!-- Debug -->
          <!-- <div>props:{{ props }}</div> -->
          <thead class="v-data-table-header">
            <tr>
              <th
                role="columnheader"
                scope="col"
                aria-label="項目"
                aria-sort="none"
                class="text-center"
              >
                <span>項目</span>
              </th>
              <th
                v-for="(head, idx) in props.props.headers"
                :key="'D' + idx"
                role="columnheader"
                scope="col"
                :aria-label="head"
                aria-sort="none"
                class="text-center"
              >
                <span class="matrix-text">{{ head }}</span>
              </th>
            </tr>
          </thead>
        </template>
        <template slot="item" slot-scope="props">
          <!-- 對於每一個 row 加上 tr 不然不會換行 -->
          <tr v-if="props.index < ques.subQues.length">
            <!-- Debug -->
            <!-- props: -->
            <!-- {{ props }} -->
            <td class="text-center">
              <span class="matrix-text">{{ props.item.cnName }}</span>
            </td>
            <td
              v-for="(header, idx) in ques.items"
              :key="'E' + idx"
              class="text-center pa-0 matrix-item-td"
              @click="ques.subQues[props.index].value = idx"
            >
              <!-- 這裡 props 的就是 slot 說明裡面的那個物件 -->
              <!-- props.index 就是目前道第幾個物件(渲染 row 的 item slot 第幾次被呼叫，0base) -->
              <!-- props.item 就是 ques.subQues[props.index] -->
              <v-radio-group
                v-model="ques.subQues[props.index].value"
                class="peter-matrix-item-radio"
              >
                <v-radio :value="idx"></v-radio>
              </v-radio-group>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-input
        :value="allFilled"
        :rules="[
          v => {
            let pass = !(ques.isRequired && !allFilled)
            return pass ? true : '此題為必填，必須完成每個選項'
          }
        ]"
      >
      </v-input>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  data() {
    return {
      tmpOpt: '',
      tmpItem: ''
    }
  },
  props: {
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: null
    }
  },
  computed: {
    allFilled() {
      return !this.ques.subQues.some(x => x.value === null)
    }
  }
}
</script>

<style>
.matrix-item-td {
  cursor: pointer;
}
.peter-matrix-item-radio {
  display: inline-block;
  cursor: pointer;
}
.matrix-text {
  font-weight: 400;
  /* 調整寬螢幕下的字體 */
  /* font-size: 1.3em; */
  /* font-size: 3vmin; */
  font-size: 22px;
}
.v-card__subtitle, .v-card__text{
  font-size: 22px;
}

/* 多頁模式的按鈕位置變化 */
@media screen and (max-width:850px) {
/* 調整窄螢幕下的字體 */
.v-card__subtitle, .v-card__text, .matrix-text {
  font-size: 18px;  
}
}
</style>
